import * as api from 'saas/pco/zones/api';
import { getIsFetching } from '../reducers/zone';

export const FETCH_ZONE = 'zone.FETCH_ZONE';
export const FETCH_ZONE_SUCCESS = 'zone.FETCH_ZONE_SUCCESS';

const requestZone = () => ({
  type: FETCH_ZONE,
});

const receiveZone = ({ zone, points, comments, markers }) => ({
  type: FETCH_ZONE_SUCCESS,
  zone,
  points: points.concat(comments).concat(markers),
});

export const fetchZone = id => (dispatch, getState) => {
  const state = getState();
  if (getIsFetching(state)) {
    return Promise.resolve();
  }

  dispatch(requestZone());

  // Request interventions fetching then planning
  return api.getZoneById(id).then(response => dispatch(receiveZone(response)));
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/actions/zone.js